module.exports = __webpack_public_path__ + "img/Deco_ceremonie.bc8b0fe.jpg";